module.exports = __webpack_public_path__ + "img/challenges.11f65185.gif";